import HeroSection from './home/HeroSection'
import QuickInfoBar from './home/QuickInfoBar'
import HorairesSection from './home/HorairesSection'
import AdresseSection from './home/AdresseSection'
import PremiereVisiteSection from './home/PremiereVisiteSection'
import MissionSection from './home/MissionSection'
import PredicationSection from './home/PredicationSection'
import DonsSection from './home/DonsSection'
export default function HomePage() {
  return (
    <div className="bg-cmp-cream">
      <HeroSection />
      <QuickInfoBar />
      <HorairesSection />
      <AdresseSection />
      <PremiereVisiteSection />
      <MissionSection />
      <PredicationSection />
      <DonsSection />
    </div>
  )
}
